import { defaultAxiosInstance } from "./defaultInstance";
import API_PATH from "../constants/apiPath";

// 실패 시 에러를 던져야 호출 측(handle401Error)이 원래 요청 재시도를 중단할 수 있다
export const refreshAccessToken = async () => {
  const response = await defaultAxiosInstance.get(
    API_PATH.refreshAccessToken
  );
  return response.data;
};

export const requestMembershipRefund = async ({ userId, refundType, refundedAmount, reason }) => {
  const response = await defaultAxiosInstance.post('/admin/membership/refund', {
    userId,
    refundType,
    refundedAmount,
    reason,
  });
  return response.data;
};